import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-[#1e3a5f] text-white pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-327">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#d4a574] opacity-5 blur-3xl rounded-l-full transform translate-x-1/2" data-id="element-328" />
      <div className="absolute bottom-0 left-0 w-1/4 h-1/2 bg-[#f4e4d7] opacity-5 blur-3xl rounded-r-full transform -translate-x-1/2" data-id="element-329" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-330">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-331">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="space-y-6" data-id="element-332">
            <div className="inline-flex items-center gap-2 bg-[#d4a574]/20 border border-[#d4a574]/30 rounded-full px-4 py-1.5 backdrop-blur-sm" data-id="element-333">
              <Sparkles className="w-4 h-4 text-[#d4a574]" data-id="element-334" />
              <span className="text-sm font-semibold text-[#d4a574] tracking-wide uppercase" data-id="element-335">
                Pack 7-en-1 Exclusivo
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight text-white" data-id="element-336">
              Finanzas Fáciles para{' '}
              <span className="text-[#d4a574] italic" data-id="element-337">Mujeres</span>
            </h1>

            <p className="text-xl md:text-2xl text-[#f4e4d7] font-light" data-id="element-338">
              30 días para pasar del caos al control financiero total.
            </p>

            <div className="space-y-3 py-4" data-id="element-339">
              {['Plan práctico de 15 minutos al día', 'Sin tecnicismos ni palabras complicadas', 'Diseñado para ingresos variables y emprendedoras', 'Acceso inmediato y de por vida'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-340">
                  <div className="mt-1 bg-[#d4a574] rounded-full p-0.5" data-id="element-341">
                    <Check className="w-3 h-3 text-[#1e3a5f]" data-id="element-342" />
                  </div>
                  <span className="text-gray-200" data-id="element-343">{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 pt-4" data-id="element-344">
              <div className="flex flex-col" data-id="element-345">
                <span className="text-gray-400 line-through text-lg" data-id="element-346">
                  Normal: $497 USD
                </span>
                <div className="flex items-baseline gap-2" data-id="element-347">
                  <span className="text-4xl font-bold text-white" data-id="element-348">$97 USD</span>
                  <span className="text-[#d4a574] font-semibold text-sm bg-[#d4a574]/10 px-2 py-1 rounded" data-id="element-349">
                    Oferta Lanzamiento
                  </span>
                </div>
              </div>

              <motion.a href="#oferta" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="w-full sm:w-auto bg-[#d4a574] hover:bg-[#c29463] text-[#1e3a5f] font-bold text-lg px-8 py-4 rounded-xl shadow-lg shadow-[#d4a574]/20 transition-all flex items-center justify-center gap-2" data-id="element-350">
                Quiero el pack ahora
                <ArrowRight className="w-5 h-5" data-id="element-351" />
              </motion.a>
            </div>

            <p className="text-sm text-gray-400 italic" data-id="element-352">
              *Oferta disponible por tiempo limitado. Acceso 100% digital.
            </p>
          </motion.div>

          {/* Visual Content - Actual Product Covers */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-353">
            <div className="relative z-10" data-id="element-354">
              {/* Main cover - prominent display */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.4
            }} className="relative" data-id="element-355">
                <img src="https://cdn.magicpatterns.com/uploads/rEbP9cdsB5wKXX71QsCx5Z/portada_finanzas_faciles.png" alt="Finanzas Fáciles para Mujeres - Guía Principal" className="w-full max-w-md mx-auto rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-356" />

                {/* Floating bonus covers - left side */}
                <motion.img initial={{
                opacity: 0,
                x: -30,
                y: 30
              }} animate={{
                opacity: 1,
                x: 0,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 0.6
              }} src="https://cdn.magicpatterns.com/uploads/82pjW85xD7qLnv8WLUSVLA/portada_bono1.png" alt="Dinero en Pareja y Familia" className="absolute -left-8 top-1/4 w-32 md:w-40 rounded-lg shadow-xl transform -rotate-6 hover:rotate-0 transition-transform duration-500" data-id="element-357" />

                <motion.img initial={{
                opacity: 0,
                x: -30,
                y: -30
              }} animate={{
                opacity: 1,
                x: 0,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 1.0
              }} src="https://cdn.magicpatterns.com/uploads/dsMDdhavFW6Br34VYUL9Sg/portada_bono_6.png" alt="Mentalidad y Afirmaciones" className="absolute -left-6 bottom-1/4 w-28 md:w-36 rounded-lg shadow-xl transform -rotate-12 hover:rotate-0 transition-transform duration-500" data-id="element-358" />

                {/* Floating bonus covers - right side */}
                <motion.img initial={{
                opacity: 0,
                x: 30,
                y: 30
              }} animate={{
                opacity: 1,
                x: 0,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 0.8
              }} src="https://cdn.magicpatterns.com/uploads/aqaWhvwqXbR7suvdSC7kHY/portada_bono2.png" alt="Plan para Salir de Deudas" className="absolute -right-8 top-1/2 w-32 md:w-40 rounded-lg shadow-xl transform rotate-6 hover:rotate-0 transition-transform duration-500" data-id="element-359" />

                <motion.img initial={{
                opacity: 0,
                x: 30,
                y: -30
              }} animate={{
                opacity: 1,
                x: 0,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 1.2
              }} src="https://cdn.magicpatterns.com/uploads/iowyRuUA8sVcfFG7ZcY8wE/portada_bono_5.png" alt="Obtén Ingresos Extra" className="absolute -right-6 bottom-1/4 w-28 md:w-36 rounded-lg shadow-xl transform rotate-12 hover:rotate-0 transition-transform duration-500" data-id="element-360" />
              </motion.div>

              {/* Trust badge */}
              <div className="absolute -top-6 -right-6 bg-white text-[#1e3a5f] p-4 rounded-xl shadow-xl transform rotate-6 animate-pulse z-20" data-id="element-361">
                <div className="flex items-center gap-1 mb-1" data-id="element-362">
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-363" />
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-364" />
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-365" />
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-366" />
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-367" />
                </div>
                <p className="font-bold text-sm" data-id="element-368">"¡Me cambió la vida!"</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}
function ArrowRight({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-369">
      <path d="M5 12h14" data-id="element-370" />
      <path d="m12 5 7 7-7 7" data-id="element-371" />
    </svg>;
}